// SMS modülünün backend uçlarıyla (backend/src/modules/sms/router.ts) konuşan
// tipler. Uygulamaya özgü kayıt tipleri burada yok.

export const SMS_ACCOUNTS = ["OTP", "BIREYSEL", "TACIR"] as const;
export type SmsAccount = (typeof SMS_ACCOUNTS)[number];

export const SMS_PURPOSES = ["OTP", "NOTIFICATION", "CAMPAIGN", "TEST"] as const;
export type SmsPurpose = (typeof SMS_PURPOSES)[number];

export const SMS_STATUSES = ["SENT", "FAILED"] as const;
export type SmsStatus = (typeof SMS_STATUSES)[number];

// GET <reportPath> satırı.
export interface SmsLogRow {
  id: string;
  createdAt: string;
  purpose: SmsPurpose;
  account: SmsAccount;
  phone: string;
  message: string;
  status: SmsStatus;
  responseCode: string | null;
  errorMessage: string | null;
  // OTP | STANDARD | STANDARD_FALLBACK (OTP paketi yokken normal hatta düşüş)
  via: string | null;
  customerName: string | null;
}

// Uygulamanın HTTP istemcisi (axios örneği doğrudan verilebilir).
export interface SmsHttp {
  get<T = unknown>(url: string, config?: { params?: Record<string, unknown> }): Promise<{ data: T }>;
  post<T = unknown>(url: string, body?: unknown): Promise<{ data: T }>;
  put<T = unknown>(url: string, body?: unknown): Promise<{ data: T }>;
  delete<T = unknown>(url: string): Promise<{ data: T }>;
}

// Uygulamanın onay penceresi (true = onaylandı).
export type SmsConfirm = (message: string) => Promise<boolean>;

// Ekrandan yönetilen SMS şablonu (GET <basePath>/sms-templates).
export interface SmsTemplate {
  id: string;
  name: string;
  body: string;
  // Uygulama olayı (ServisPro'da servis durumu); null = her durumda.
  event: string | null;
  autoSend: boolean;
  manualSend: boolean;
  sortOrder: number;
}

export interface SmsTemplateEvent {
  key: string;
  label: string;
}

// Şablonlarda kullanılabilen alan ({key}) — ekrandan yönetilir. Değeri bir
// veri kaynağından (source) ya da sabit metinden (fixedValue) gelir.
export interface SmsVariable {
  id: string;
  key: string;
  label: string;
  source: string | null;
  fixedValue: string | null;
  sortOrder: number;
}

// Alanın değerini alabileceği veri kaynakları (uygulamaya özgü, backend'den gelir).
export interface SmsVariableSource {
  key: string;
  label: string;
}

// "SMS Gönder" düğmesinde seçilebilecek şablonlar: önce olaya bağlı olanlar,
// sonra olaysız (her durumda geçerli) olanlar. Backend ile aynı kural.
export function manualTemplatesFor(templates: SmsTemplate[], event: string | null): SmsTemplate[] {
  const manual = templates.filter((t) => t.manualSend);
  return [...manual.filter((t) => event !== null && t.event === event), ...manual.filter((t) => t.event === null)];
}

// Uygulamanın bildirim/uyarı penceresi.
export type SmsNotify = (message: string, variant: "info" | "danger") => Promise<unknown> | void;

// Sunucu hata yanıtından { message, raw } (axios biçimi; başka istemcide boş).
export function errorDetails(err: unknown): { message?: string; raw?: string } {
  const data = (err as { response?: { data?: { message?: unknown; raw?: unknown } } })?.response?.data;
  return {
    message: typeof data?.message === "string" ? data.message : undefined,
    raw: typeof data?.raw === "string" ? data.raw : undefined,
  };
}

// "SMS Gönder" penceresindeki önizleme (uygulamanın önizleme ucu; backend
// createSmsPreviewHandler). Gönderilecek mesajın son hâli.
export interface SmsPreview {
  templateId: string;
  templateName: string;
  message: string;
  account: SmsAccount;
  phone: string;
  length: number;
  // Tahmini SMS adedi.
  segments: number;
}
